import { Api } from './api';
import { getPlatform, Platform } from '../platform/platform';

/**
 * Вход и привязка clientId Метрики — ручки /auth/*.
 */
export class AuthApi {
    private static readonly PATH = '/auth';

    constructor(private readonly m_api: Api) {}

    public async login(
        initData: string | undefined,
        appDataObj: { ref: string; clientId: string; yclid: string },
    ) {
        if (initData === '' || initData === undefined) {
            if (getPlatform() === Platform.Desktop) {
                initData = process.env.REACT_APP_TEMP_INIT_DATA!;
            }
        }

        const appData = JSON.stringify(appDataObj);
        const data = await this.m_api.post(`${AuthApi.PATH}/login`, { initData, appData });

        if (data?.accessToken) {
            this.m_api.setAccessToken(data.accessToken);
        }

        return data;
    }

    public async saveClientId(clientId: string): Promise<void> {
        await this.m_api.post(`${AuthApi.PATH}/client-id`, { clientId });
    }
}
